export const environment = {
  production: false,
  enableLogs: true,
  appVersion: '1.0.0',
  statusStatsAllowedResume: ['Pending-Analysis', 'Pending-Fulfillment'],
  featureFlagKey: 'sdk-Y8Vy6LFYW4VtjqlI',
  logRocketEnabled: false,
  apiUrl: 'https://api-sqa.bhd.com.do',
  platform: 'WEB',
  channel: 'WEB',
  productType: 'TC',
  userImgPath: 'assets/images/user2.svg',
  siteKey: '6LeAuYkkAAAAAJbI_sREl9SziNusDeROCLVoLD9e',
  scope: 'CreditCardWeb',
  angularPegaUrl: 'https://bhd-az-appservice-eastus2-zbdotc-sqa-001.azurewebsites.net/OriginationTCPega',
  vuKey: '50669256-2a54-00e7-782a-b74d01a2855e',
  env: 'SQA',
  logRocketKey: 'cfr9nf/test-log',
  enrollUrl: '/bhdleon/api/v1/web/personal/enrollment',
  storageKey: '4b8e8ee8-8e4b-4e8e-b8e4-8e4b8e8ee8e4',
  facephiKey: 'Ja8VXZxFb5TyHsVomfVUIvQlsDB1aZZmw2nMSnOr',
  hostname: 'bhd-az-appservice-eastus2-zbdotc-sqa-001.azurewebsites.net'
};
